import { render, staticRenderFns } from "./GroupCreatedList.vue?vue&type=template&id=1a837dc3&scoped=true"
import script from "./GroupCreatedList.vue?vue&type=script&lang=js"
export * from "./GroupCreatedList.vue?vue&type=script&lang=js"
import style0 from "./GroupCreatedList.vue?vue&type=style&index=0&id=1a837dc3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a837dc3",
  null
  
)

export default component.exports